export default () => {
    var customerLogin = document.querySelector("#formLogin.csrf-enabled .form-group .login-wrapper");

    if (customerLogin) {
        var loginButton = document.querySelector("#formLogin.csrf-enabled .form-group .login-wrapper .btn.btn-secondary.btn-text.btn-login");

        if (loginButton)
        {
            $('<div/>', {
                class: 'login-button-wrapper'
            }).appendTo('#formLogin.csrf-enabled .form-group .login-wrapper');

            $('#formLogin.csrf-enabled .form-group .login-wrapper .btn.btn-secondary.btn-text.btn-login').detach().appendTo('.login-wrapper .login-button-wrapper');
        }
    }
};